import React, { useEffect } from 'react';

import { StandardEventProperties, track, useFlowState } from '@betterment/js-runtime';

import SuccessOverlay from './SuccessOverlay';

import { gtmTrack } from '../google-tag-manager-helpers';
import { locationAssign } from '../path-helpers';

export interface SuccessStepProps {
  redirectTo?: string;
  onSuccess?: () => void;
  message: string;
  eventProperties?: StandardEventProperties;
  gtmProperties?: string;
}

const SuccessStep: React.FC<React.PropsWithChildren<SuccessStepProps>> = ({
  message,
  redirectTo,
  onSuccess,
  eventProperties,
  gtmProperties,
}) => {
  const {
    flowState: { returnToPath },
  } = useFlowState();

  const navigateCompleted = () => {
    if (onSuccess) {
      onSuccess();
    } else {
      locationAssign(redirectTo || returnToPath);
    }
  };

  useEffect(() => {
    if (eventProperties) {
      track('ElementViewed', eventProperties);
    }

    if (gtmProperties) {
      gtmTrack(gtmProperties);
    }
  }, [eventProperties, gtmProperties]);

  return <SuccessOverlay message={message} onCompletion={navigateCompleted} />;
};

export default SuccessStep;
